import {
  ChakraBox,
  FAIconName,
  FireflyButton,
  ModalV2,
  Text,
} from '@equip.health/ui';

interface DraftNotesConflictModalProps {
  isOpen: boolean;
  onClose: () => void;
  onCloseParent?: () => void;
  operation: 'create' | 'void';
}

const TOP_LEVEL_ID = 'draft-notes-conflict-modal';

const TITLE_MAP = {
  create: 'Unable to create new care plan',
  void: 'Unable to void care plan',
};

export const DraftNotesConflictModal = ({
  isOpen,
  onClose,
  onCloseParent,
  operation,
}: DraftNotesConflictModalProps) => {
  return (
    <ModalV2
      isOpen={isOpen}
      onClose={onClose}
      size="md"
      title={TITLE_MAP[operation]}
      footerContent={
        <ChakraBox paddingTop="6px">
          <FireflyButton
            id={`${TOP_LEVEL_ID}-close-button`}
            leftIcon={FAIconName.timesRegular}
            onClick={() => {
              onClose();
              onCloseParent?.();
            }}
            variant="secondary"
            width="100%"
          >
            Close
          </FireflyButton>
        </ChakraBox>
      }
    >
      <Text
        color="var(--neutral-primary-90, #1E2026)"
        sx={{
          fontFamily: 'Pangea Text',
          fontSize: '15px',
          fontStyle: 'normal',
          fontWeight: '400',
          lineHeight: '140%',
          letterSpacing: '-0.45px',
        }}
      >
        There are one or more draft notes with unsaved changes to this care
        plan. Please try again after the note(s) have been signed.
      </Text>
    </ModalV2>
  );
};
